<span *ngIf="0">Is External user {{ isExternalUser$ | async }}</span>

<app-pending-container [isPending]="!!(pending$ | async)" sticky>
    @if(0) {
    <p>Current user language {{ language }}</p>
    }

    @if(isContentLoading$ | async) {
    <app-loading-spinner />
    }

    <div class="content-container">
        <quill-view [content]="(rawHtml$ | async)!" contentType="delta"></quill-view>

        <button mat-flat-button color="primary" type="button" class="align-right mt-40 mb-40" (click)="confirm()">
            {{ 'terms-update.confirm-btn-text' | translate }}
        </button>
    </div>



</app-pending-container>